export const findFirstUyoImage = (canvasInstance) => {
  if (!canvasInstance) return null;

  const objects = canvasInstance.getObjects();
  const uyoImages = objects.filter((obj) => obj.type === 'uYOImage') ?? [];
  return uyoImages.find((img) => img.variant === 'logo') ?? uyoImages[0];
};

export const selectFirstUyoImage = (canvasInstance) => {
  if (!canvasInstance) return false;

  const firstUyoImage = findFirstUyoImage(canvasInstance);

  if (firstUyoImage) {
    canvasInstance.setActiveObject(firstUyoImage);
    canvasInstance.requestRenderAll();
    return true;
  }

  return false;
};

export const triggerSelectFirstUyo = (canvasInstance) => {
  if (!canvasInstance) return false;

  canvasInstance.fire('canvas:uyo:select:first');
  return true;
};
